module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/admin-layout/admin-layout.component.scss
// module id = ./src/app/containers/admin-layout/admin-layout.component.scss
// module chunks = main